export const USER_STATUS = {
  LOGGED: "LOGGED",
  REMEMBERED: "REMEMBERED",
  NOT_LOGGED: "NOT_LOGGED",
  LOADING: "LOADING"
};